export default "__VITE_ASSET__icpj2002__"